import { useState, useEffect, useRef, useLayoutEffect  } from 'react';
import api from '../api/api';
import InventoryForm from './InventoryForm'; // Adjust path accordingly
import './css/OrdersPage.css';
import TopNav from '../components/TopNav';
import ConfirmModal from '../components/ConfirmModal';
import AlertModal from '../components/AlertModal';
import { useAuth } from '../context/AuthContext';
import wsUrl from '../api/wsUrl';

function OrdersPage() {
  const [inventory, setInventory] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [orders, setOrders] = useState([]);
  const [serialNumberError, setSerialNumberError] = useState('');
  const [matchedInventoryItem, setMatchedInventoryItem] = useState(null);
  const [matchedInventoryItems, setMatchedInventoryItems] = useState([]);
  const [matchedOrders, setMatchedOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [editedServicesMap, setEditedServicesMap] = useState({});
  const [showAddToInventory, setShowAddToInventory] = useState(false);
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [trackingOrderId, setTrackingOrderId] = useState(null);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [trackingInput, setTrackingInput] = useState('');
  const [groupTrackingInputs, setGroupTrackingInputs] = useState({});
  const { user, logout } = useAuth();
  const [file, setFile] = useState(null);
  const [uploadStatus, setuploadStatus] = useState('');
  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000'
  const [fileMap, setFileMap] = useState({});
  const [uploadStatusMap, setUploadStatusMap] = useState({});
  const [selectedFilesMap, setSelectedFilesMap] = useState({});
  const [videoModalUrl, setVideoModalUrl] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewType, setPreviewType] = useState(null); // 'image' or 'video'
  const [existingOrderLink, setExistingOrderLink] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [uploadingOrderId, setUploadingOrderId] = useState(null); // or store per-order flags if multiple
  const [uploadProgressMap, setUploadProgressMap] = useState({});
  const [newNote, setNewNote] = useState('');
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);
  const [messages, setMessages] = useState({}); 
  const messagesContainerRefs = useRef({});
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const [factoryFilter, setFactoryFilter] = useState('All'); // 'All' or provider_id as string

  


  const [confirmState, setConfirmState] = useState({
    open: false,
    message: '',
    onConfirm: () => {},
  });

  const handleSendMessage = async (id, text) => {

  if (text === '' || text.length === 0 || !text.trim()) return;

  const msgObj = {
    text,
    sender: user?.name || 'You',
    timestamp: new Date().toISOString(),
  };


  const existingNotesRes = await api.get(`/orders/${id}`);

  let existingNotes = [];

try {
  const rawNotes = existingNotesRes.data.notes;

  existingNotes = Array.isArray(rawNotes)
    ? rawNotes
    : JSON.parse(rawNotes || '[]');

  if (!Array.isArray(existingNotes)) {
    console.warn('Parsed notes is not an array:', existingNotes);
    existingNotes = [];
  }
} catch (err) {
  console.error('Failed to parse existing notes:', err);
  existingNotes = [];
}


 const updatedNotes = [...existingNotes, msgObj];

await api.put(`/orders/${id}`, { notes: JSON.stringify(updatedNotes) });

  setMessages(prev => ({
    ...prev,
    [id]: [...(prev[id] || []), msgObj]
  }));

  setTimeout(() => {
  const container = messagesContainerRefs.current[id];
  if (container) {
    container.scrollTop = container.scrollHeight;
  }
}, 50);

};

const scrollAllChatsToBottom = () => {
  Object.values(messagesContainerRefs.current).forEach(container => {
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  });
};

 const [alertState, setAlertState] = useState({
    open: false,
    message: '',
  });

  const showAlert = (message) => {
    setAlertState({ open: true, message });
  };

  const askConfirm = (message, onConfirm) => {
    setConfirmState({
      open: true,
      message,
        onConfirm: () => {
        onConfirm();
        setConfirmState({ open: false, message: '', onConfirm: () => {} });
      },
    });
  };


  const openPreviewModal = (fileUrl) => {
    const ext = fileUrl.split('.').pop().toLowerCase();
    if (['mp4', 'mpeg', 'mov'].includes(ext)) {
      setPreviewType(ext);
    } else if (['jpg', 'jpeg', 'png'].includes(ext)) {
      setPreviewType('image');
    } else {
      setPreviewType(null);
    }
    setPreviewUrl(fileUrl);
  };


  const [form, setForm] = useState({
    inventory_id: '',
    provider_id: '',
    services_selected: '',
    returnbydate: null,
    status: ''
  });

  const loadData = () => {
    api.get('/inventory').then(res => setInventory(res.data));
    api.get('/providers').then(res => {
    setProviders(res.data);
    const defaultProvider = res.data.find(p => p.is_default);
    if (defaultProvider) {
      setForm(form => ({ ...form, provider_id: defaultProvider.id }));
      setSelectedProvider(defaultProvider);
      if (defaultProvider.services_offered) {
        setServices(defaultProvider.services_offered.split(',').map(s => s.trim()));
      }
    }
    
  });
    
    fetchOrders();
  };

  useEffect(() => {
    document.title = "Orders - Services Irene's Wigs.com";
    loadData();
  }, []);

  useEffect(() => {
  if (orders.length > 0) {
    orders.forEach(order => {
      fetch(`${API_BASE}/orders/${order.id}/files`, {
        credentials: 'include'
      })
        .then(res => res.json())
        .then(files => {
          setFileMap(prev => ({ ...prev, [order.id]: files }));
        })
        .catch(err => console.error('Failed to fetch files:', err));
    });
  }
}, [orders]);

const handleSelectInventoryItem = (item) => {
  setForm(prev => ({
    ...prev,
    inventory_id: item.id,
    serial_number: item.serial_number,
    returnbydate: form.returnbydate || null
  }));
  setMatchedInventoryItems([]);
  setSerialNumberError('');

  // ✅ Check if there's an order for this item
  const existingOrder = orders.find(
    order => order.inventory_id === item.id && order.status !== 'Completed'
  );

  const completedOrder = orders.find(
    order => order.inventory_id === item.id && order.status === 'Completed'
  );

  if (existingOrder) {
    setSerialNumberError(
      <span>
        This item already has an active order (Order ID:{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleViewOrder(existingOrder.id);
          }}
          style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
        >
          {existingOrder.id}
        </a>
        ).
      </span>
    );
  }

  if (completedOrder) {
    setSerialNumberError(
      <span>
        This item already has an completed order (Order ID:{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleViewOrder(completedOrder.id, 'Completed');
          }}
          style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
        >
          {completedOrder.id}
        </a>
        ).
      </span>
    );
  }

};

const findExistingOrder = (item) => {
  if (!item || !Array.isArray(orders) || orders.length === 0) return null;

  const active = orders.filter(
    (o) => o.inventory_id === item.id && o.status !== 'Completed'
  );
  const completed = orders.filter(
    (o) => o.inventory_id === item.id && o.status === 'Completed'
  );

  // nothing to display
  if (active.length === 0 && completed.length === 0) return null;

  return (
    <span style={{ marginLeft: 8 }}>
      {active.length > 0 && (
        <>
          {' - Active Order'}
          {active.length > 1 ? 's' : ''}:{' '}
          {active.map((o, idx) => (
            <a
              key={`active-${o.id}`}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleViewOrder(o.id);
              }}
              style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
            >
              {o.id}
              {idx < active.length - 1 ? ', ' : ''}
            </a>
          ))}
        </>
      )}

      {completed.length > 0 && (
        <>
          {active.length > 0 ? ' ; ' : ' - '}
          {'Completed Order'}
          {completed.length > 1 ? 's' : ''}:{' '}
          {completed.map((o, idx) => (
            <a
              key={`completed-${o.id}`}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleViewOrder(o.id, 'Completed');
              }}
              style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
            >
              {o.id}
              {idx < completed.length - 1 ? ', ' : ''}
            </a>
          ))}
        </>
      )}
    </span>
  );
};


const handleViewOrder = async (orderId, status) => {
  const order = orders.find(o => o.id === orderId);
  //console.log('order', order)
  if (order) {
    try {
      //const res = await api.get(`/orders/${orderId}`);
      setStatusFilter(status ?? 'All');
             
      setOrders([order]);
      //setMatchedInventoryItem('')
      setMatchedInventoryItems([])
      // optionally add it to your orders list
    } catch (err) {
      console.error('Failed to fetch order:', err);
    }
  }
};

function tryParseJSON(str) {
  try {
    const parsed = JSON.parse(str);
    // Accept only if parsed is an object or array (optional)
    if (parsed && typeof parsed === 'object') {
      return parsed;
    }
  } catch (e) {
    // Not JSON, return null or undefined
  }
  return null;
}

const findItem = () => {
  const serialNumber = form.serial_number?.trim();
  setOrders(allOrders)
  setMatchedInventoryItem('');
  if (!serialNumber) {
    setMatchedInventoryItems([]);
    setSerialNumberError('');
    //setForm(prev => ({ ...prev, inventory_id: '' }));
    setShowAddToInventory(false);
    setShowInventoryModal(false);
    return;
  }

  const searchValue = serialNumber.toLowerCase();
  
  const matches = inventory.filter(item =>
    item.serial_number.toLowerCase().includes(searchValue) ||
    item.name.toLowerCase().includes(searchValue)
  );
  
  let hasActiveOrder = []
  // ✅ If one item found and no active order, auto-select it
  if (matches.length === 1) {
    const item = matches[0];
    hasActiveOrder = orders.filter(
      order => order.inventory_id === item.id //&& order.status !=='Completed'
    );

    
    setMatchedOrders(hasActiveOrder);
    if (!hasActiveOrder) {
      // Auto-set the form and matched item
      setForm(prev => ({
        ...prev,
        inventory_id: item.id,
        serial_number: item.serial_number
      }));
      setMatchedInventoryItem(item);
      setSerialNumberError('');
      return;
    }
  }

  if (matches.length > 0) {
    setMatchedInventoryItems(matches);
    setSerialNumberError('');
    setShowAddToInventory(false);
    setShowInventoryModal(false);
  } else {
    setMatchedInventoryItems([]);
    setSerialNumberError('No inventory item found with that serial number.');
    //setForm(prev => ({ ...prev, inventory_id: '' }));

    askConfirm('Serial number not found. Would you like to add this item to inventory?', () => {
      setShowAddToInventory(true);
      setShowInventoryModal(true);
    });
  }
};




const handleShip = (id) => {
  setTrackingOrderId(id);
  setTrackingNumber('');
  setShowTrackingModal(true);
};

const submitTrackingNumber = async (updatedOrders) => {
  console.log('selectedOrders', updatedOrders)
  
  setTrackingOrderId('bulk')

  console.log('trackingOrderId', trackingOrderId)
  try {
    if (trackingOrderId === 'bulk') {
      // Apply tracking number to all selected orders
      await Promise.all(
        updatedOrders.map(order =>
          api.put(`/orders/${order.id}`, {
            status: 'Shipped to Factory',
            tracking_number_in: trackingNumber
          })
        )
      );
      //setSelectedOrders([]);
    } else {
      // Single order shipment
      await api.put(`/orders/${trackingOrderId}`, {
        status: 'Shipped',
        tracking_number: trackingNumber
      });
    }

    // Reset state and close modal
    setShowTrackingModal(false);
    setTrackingOrderId(null);
    setTrackingNumber('');
    fetchOrders();
  } catch (err) {
    console.error('Error updating tracking number:', err);
  }
};


const handleSave = async (id) => {
  const order = orders.find(o => o.id === id);
  if (!order) return;

  const updatedServices =
    editedServicesMap[id] || (order.services_selected ? order.services_selected.split(',').map(s => s.trim()) : []);


  try {
    await api.put(`/orders/${id}`, {
      inventory_id: order.inventory_id,
      provider_id: order.provider_id,
      services_selected: updatedServices.join(', '), // ✅ Use edited services
      tracking_number: order.tracking_number,
      returnbydate: order.returnbydate,
      returnetadate: order.returnetadate,
      status: 'Updated'
      
    });
    fetchOrders(); // Refresh list
  } catch (err) {
    console.error('Error saving order:', err);
  }
};


const fetchOrders = async () => {
  try {
    const res = await api.get('/orders');
    setOrders(res.data);
    setAllOrders(res.data); // optional filtering support
//console.log('res.data', res.data)
    const messagesMap = {};

    res.data.forEach(order => {
  try {
    let parsed = [];

    if (Array.isArray(order.notes)) {
      parsed = order.notes;
    } else if (typeof order.notes === 'string' && order.notes.trim() !== '') {
      try {
        const attempt = JSON.parse(order.notes);
        if (Array.isArray(attempt)) {
          parsed = attempt;
        } else {
          // Not an array, fallback to wrapping string
          parsed = [order.notes];
          console.warn(`Order ${order.id} notes is not a JSON array, using raw string`);
        }
      } catch {
        // JSON parse failed, fallback to wrapping string
        parsed = [order.notes];
        console.warn(`Order ${order.id} notes is invalid JSON, using raw string`);
      }
    }

    messagesMap[order.id] = parsed;
  } catch (e) {
    console.error(`Failed to parse notes for order ${order.id}`, e);
    messagesMap[order.id] = [];
  }
});



    setMessages(messagesMap);
    setTimeout(() => {
      scrollAllChatsToBottom();
    }, 100);
  } catch (err) {
    console.error('Error fetching orders:', err);
  }
};


function detectCarrier(trackingNumber) {
  if (!trackingNumber) return null;

  const fedexRegex = /^\d{12,15}$/;
  const upsRegex = /^1Z[0-9A-Z]{16}$/i;

  if (upsRegex.test(trackingNumber)) return 'ups';
  if (fedexRegex.test(trackingNumber)) return 'fedex';

  return null; // or 'unknown'
}

function getTrackingLinkAuto(trackingNumber) {
  const carrier = detectCarrier(trackingNumber);
  if (!carrier) return null;

  switch (carrier) {
    case 'fedex':
      return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNumber}`;
    case 'ups':
      return `https://www.ups.com/track?loc=en_US&tracknum=${trackingNumber}`;
    default:
      return null;
  }
}

  const handleProviderChange = (e) => {
    const providerId = e.target.value;
    const provider = providers.find(p => p.id == providerId);
    setForm({ ...form, provider_id: providerId });
    setSelectedProvider(provider);
    if (provider?.services_offered) {
      setServices(provider.services_offered.split(',').map(s => s.trim()));
    } else {
      setServices([]);
    }
    setSelectedServices([]);
  };
  

  const handleDelete = async (id) => {

  askConfirm('Are you sure you want to delete this order?', async () => {
    try {
      await api.delete(`/orders/${id}`);
      fetchOrders(); // refresh the list
    } catch (err) {
      console.error('Error deleting order:', err);
    }
  });
};


  const toggleService = (service) => {
    setSelectedServices(prev =>
      prev.includes(service) ? prev.filter(s => s !== service) : [...prev, service]
    );
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!form.inventory_id) {
    setSerialNumberError('Please enter a valid serial number before submitting.');
    return;
  }

  const duplicateOrder = orders.find(
    order => order.inventory_id === form.inventory_id && order.status !== 'Completed'
  );
  if (duplicateOrder) {
    setSerialNumberError('A repair order already exists for this item.');
    return;
  }

  try {
    setSerialNumberError('');

    await api.post('/orders', {
      ...form,
      //provider_name: selectedProviderData?.name || '',
      services_selected: selectedServices.join(', '),
      status: form.status || 'New',
      returnbydate: returnDate || null
    });

    setStatusFilter('All')
    const defaultProvider = providers.find(p => p.is_default);



    setForm({
      inventory_id: '',
      provider_id: defaultProvider?.id || '',
      services_selected: '',
      //returnbydate: null,
      status: '',
      
    });

    setSelectedProvider(defaultProvider || null);
    setSelectedServices([]);
    setServices(
      defaultProvider?.services_offered
        ? defaultProvider.services_offered.split(',').map(s => s.trim())
        : []
    );
    setMatchedInventoryItem('')
    loadData();
  } catch (err) {
    console.error('Error creating order:', err);
  }
};



const handleComplete = async (id) => {
  try {
    await api.put(`/orders/${id}`, { status: 'Completed' });
    fetchOrders(); // Refresh the list after update
  } catch (err) {
    console.error('Error completing order:', err);
  }
};

  const handleCancel = async (id) => {
  try {
    await api.put(`/orders/${id}`, { status: 'Canceled' });
    fetchOrders(); // Refresh the list after update
  } catch (err) {
    console.error('Error canceling order:', err);
  }
};

const handleSerialNumberChange = (e) => {
  const serialNumber = e.target.value.trim();
  setForm((prev) => ({ ...prev, serial_number: serialNumber }));
};



const bulkDelete = async () => {
  askConfirm('Are you sure you want to delete selected orders?', async () => {
  await Promise.all(selectedOrders.map(id => api.delete(`/orders/${id}`)));
  setSelectedOrders([]);
  fetchOrders();
  })
};

const CreateShipOrder = async () => {
  if (!selectedOrders.length) return;

  const selectedOrderObjects = orders.filter(order => selectedOrders.includes(order.id));

  const uniqueProviderIds = [...new Set(selectedOrderObjects.map(order => order.provider_id))];
  if (uniqueProviderIds.length > 1) {
    showAlert('All selected orders must belong to the same provider.');
    return;
  }

  const selectedSerials = selectedOrderObjects.map(order => {
    const item = inventory.find(i => i.id === order.inventory_id);
    return item?.serial_number || '';
  });

  const alreadyGrouped = orders.filter(order => {
    const serial = inventory.find(i => i.id === order.inventory_id)?.serial_number;
    return serial && selectedSerials.includes(serial) && order.shipping_group;
  });

  if (alreadyGrouped.length > 0) {
    const serials = alreadyGrouped.map(order => {
      const serial = inventory.find(i => i.id === order.inventory_id)?.serial_number;
      return serial || 'Unknown';
    }).join(', ');
    showAlert(`The following serial numbers are already in a shipping group: ${serials}`);
    return;
  }

  const providerId = uniqueProviderIds[0];
  const providerName = providers.find(p => p.id === providerId)?.name?.replace(/\s+/g, '') || 'UnknownProvider';
  const shippingGroup = `${providerName}:${selectedSerials.join('-')}`;

  await Promise.all(
    selectedOrders.map(id =>
      api.put(`/orders/${id}`, {
        status: 'Pending Shippment',
        shipping_group: shippingGroup
      })
    )
  );

  setSelectedOrders([]);
  fetchOrders();
};

const bulkBacktoQueue = async () => {
  // Always use a fresh snapshot if you keep both `orders` and `allOrders`
  const currentOrders = Array.isArray(allOrders) && allOrders.length ? allOrders : orders;

  if (!Array.isArray(currentOrders) || !Array.isArray(selectedOrders)) {
    showAlert('No orders selected.');
    return;
  }

  const normStatus = (s) => (s ?? '').toString().trim().toLowerCase();
  const isCompleted = (s) => normStatus(s) === 'completed';
  const isActive = (s) => !isCompleted(s); // or enumerate allowed active statuses if you prefer

  // Normalize selected IDs to numbers (or to strings consistently)
  const toNum = (v) => (typeof v === 'string' ? Number(v) : v);
  const selectedSet = new Set(selectedOrders.map(toNum));

  // Only selected & completed
  const toQueue = currentOrders.filter(
    (o) => selectedSet.has(toNum(o.id)) && isCompleted(o.status)
  );

  if (toQueue.length === 0) {
    showAlert('No selected orders are marked as "Completed".');
    return;
  }

  // Index ALL active orders by inventory_id
  const activeByInventory = new Map();
  for (const o of currentOrders) {
    if (isActive(o.status)) {
      const key = o.inventory_id ?? '__NO_INV_ID__';
      const arr = activeByInventory.get(key) || [];
      arr.push(o);
      activeByInventory.set(key, arr);
    }
  }

  // Find conflicts
  const conflicts = [];
  for (const o of toQueue) {
    const key = o.inventory_id ?? '__NO_INV_ID__';

    // If inventory_id is missing, treat as conflict (we cannot guarantee safety)
    if (key === '__NO_INV_ID__') {
      conflicts.push({ order: o, actives: [] });
      continue;
    }

    const actives = (activeByInventory.get(key) || []).filter(a => toNum(a.id) !== toNum(o.id));
    if (actives.length > 0) {
      conflicts.push({ order: o, actives });
    }
  }

  if (conflicts.length > 0) {
    const details = conflicts.map(({ order, actives }) => {
      const list = actives.length ? actives.map(a => a.id).join(', ') : 'unknown (missing inventory_id)';
      return `Order ${order.id} conflicts with active order(s): ${list}`;
    }).join('\n');

    showAlert(
      `Cannot move back to Queue because active order(s) exist for the same inventory item.\n${details}`
    );
    return; // ❌ block everything if any conflict exists
  }

  // ✅ Safe to proceed
  askConfirm(
    `Are you sure you want to move ${toQueue.length} order(s) back to Queue?`,
    async () => {
      try {
        await Promise.all(
          toQueue.map(o =>
            api.put(`/orders/${o.id}`, { status: 'Updated', completed_date: null })
          )
        );
        setSelectedOrders([]);
        fetchOrders();
      } catch (err) {
        console.error('bulkBacktoQueue failed:', err);
        showAlert('Failed to move one or more orders. Please try again.');
      }
    }
  );
};


const bulkPaid = async () => {
  const Paid = orders.filter(order =>
    selectedOrders.includes(order.id) 
  );

  askConfirm(`Are you sure you want to pay ${Paid.length} order(s)?`, async () => {
    const date = new Date();
    const PaidDate = formatDate(date);
    await Promise.all(Paid.map(order =>
      api.put(`/orders/${order.id}`, { status: 'Paid',  paid_on: PaidDate })
    ));
    setSelectedOrders([]);
    fetchOrders();
  });
};

const bulkComplete = async () => {
  if (!selectedOrders.length) {
    showAlert('No orders selected.');
    return;
  }

  // Quick lookup for provider by id
  const providerById = new Map(providers.map(p => [Number(p.id), p]));

  // Split selected orders by provider delivery type
  const selectedOrderObjs = orders.filter(o => selectedOrders.includes(o.id));

  const normalizeDelivery = (v) => (String(v ?? '').trim().toLowerCase() === 'local' ? 'Local' : 'Shipping');

  const locals = [];
  const shippingsWithTracking = [];
  const shippingsMissingTracking = [];

  selectedOrderObjs.forEach((o) => {
    const provider = providerById.get(Number(o.provider_id));
    const delivery = normalizeDelivery(provider?.delivery);

    if (delivery === 'Local') {
      // Local orders can complete regardless of tracking
      locals.push(o);
    } else {
      // Shipping: require tracking_number_out
      if (o.tracking_number_out && String(o.tracking_number_out).trim() !== '') {
        shippingsWithTracking.push(o);
      } else {
        shippingsMissingTracking.push(o);
      }
    }
  });

  const toComplete = [...locals, ...shippingsWithTracking];

  if (toComplete.length === 0) {
    // Nothing eligible
    const missingList = shippingsMissingTracking.map(o => `#${o.id}`).join(', ');
    const msg = shippingsMissingTracking.length
      ? `Cannot complete: Shipping orders missing return tracking: ${missingList}`
      : 'No selected orders are eligible to complete.';
    showAlert(msg);
    return;
  }

  const skippedCount = shippingsMissingTracking.length;
  const confirmMsg = [
    `Complete ${toComplete.length} order(s)?`,
    skippedCount ? `\n\nSkipped ${skippedCount} Shipping order(s) missing return tracking.` : ''
  ].join('');

  askConfirm(confirmMsg, async () => {
    try {
      const date = new Date();
      const CompleteDate = formatDate(date);

      await Promise.all(
        toComplete.map(order =>
          api.put(`/orders/${order.id}`, { status: 'Completed', completed_date: CompleteDate })
        )
      );

      if (skippedCount) {
        const list = shippingsMissingTracking.map(o => `#${o.id}`).join(', ');
        showAlert(`Completed ${toComplete.length} order(s). Skipped (missing return tracking): ${list}`);
      }

      setSelectedOrders([]);
      fetchOrders();
    } catch (err) {
      console.error('bulkComplete failed:', err);
      showAlert('Failed to complete one or more orders. Please try again.');
    }
  });
};



const bulkCancel = async () => {
  askConfirm('Are you sure you want to cancel selected orders?', async () => {
    await Promise.all(selectedOrders.map(id => api.put(`/orders/${id}`, { status: 'Canceled' })));
    setSelectedOrders([]);
    fetchOrders();
  })
};

const bulkShip = () => {
  if (selectedOrders.length === 0) return;
  setTrackingOrderId('bulk'); // Use 'bulk' as a flag
  setTrackingNumber('');
  setShowTrackingModal(true);
};
const uniqueGroups = Array.from(new Set(orders.map(order => order.shipping_group).filter(Boolean)));
const ShippingQue = () => {
  

  if (uniqueGroups.length === 0) return;
  setTrackingOrderId('bulk'); // Use 'bulk' as a flag
  setTrackingNumber('');
  setShowTrackingModal(true);
};

const handleReturnDate = async (newDate) => {

  setForm({ ...form, returnbydate: newDate })
  setReturnDate(newDate)
};

const handleAppointmentDate = async (newDate) => {

  setForm({ ...form, appointment_date: newDate })
  setAppointmentDate(newDate)
};

const handleReturnDateChange = async (orderId, newDate) => {
  
  const parsedDate = newDate?.trim() === '' ? null : newDate;
  console.log('parsedDate', parsedDate)
  try {
    // Update UI state
    setOrders(prev =>
      prev.map(order =>
        order.id === orderId
          ? { ...order, returnbydate: parsedDate, status: 'Updated' }
          : order
      )
    );

    // Persist change to backend
    await api.put(`/orders/${orderId}`, {
      returnbydate: parsedDate,
      status: 'Updated',
    });
  } catch (err) {
    console.error('Failed to update return date:', err);
  }
};

const handleAppointmentDateChange = async (orderId, newDate) => {
  
  const parsedDate = newDate?.trim() === '' ? null : newDate;
//console.log('parsedDate', parsedDate)
  try {
    // Update UI state
    setOrders(prev =>
      prev.map(order =>
        order.id === orderId
          ? { ...order, appointment_date: parsedDate, status: 'Updated' }
          : order
      )
    );

    // Persist change to backend
    await api.put(`/orders/${orderId}`, {
      appointment_date: parsedDate,
      status: 'Updated',
    });
  } catch (err) {
    console.error('Failed to update appointment date:', err);
  }
};




const formatDate = (isoDateStr) => {
  if (!isoDateStr) return '';
  const date = new Date(isoDateStr);
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

const handleAssignTracking = async (group) => {
  const trackingNumber = groupTrackingInputs[group]?.trim();
  if (!trackingNumber) return;

  const ordersInGroup = orders.filter(order => order.shipping_group === group);
  const date = new Date();
  const NewDate = formatDate(date); 
  try {
    await Promise.all(
      ordersInGroup.map(order =>
        api.put(`/orders/${order.id}`, {
          tracking_number_in: trackingNumber,
          status: 'Shipped to Factory',
          tracking_number_in_date: NewDate,
          shipping_group: '' // Clear the group
          
        })
      )
    );

    setGroupTrackingInputs(prev => ({ ...prev, [group]: '' }));
    fetchOrders(); // Refetch from backend
  } catch (err) {
    console.error('Failed to assign tracking number:', err);
  }
};


const RemoveFromShippingGroup = async () => {
  if (!selectedOrders.length) return;

  askConfirm('Are you sure you want to remove selected items from their shipping orders?', async () => {

    await Promise.all(
      selectedOrders.map(id =>
        api.put(`/orders/${id}`, {
          shipping_group: '',
          status: 'Removed from Shipping Order' 
        })
      )
    );

    setSelectedOrders([]);
    fetchOrders();
  })
};


const handleRemoveFromGroup = async (order) => {
  askConfirm(`Remove Order ${order.id} from this shipping order "${order.shipping_group}"?`, async () => {
  
    try {
      await api.put(`/orders/${order.id}`, { shipping_group: '' });
      fetchOrders(); // Refresh order list
    } catch (err) {
      console.error('Failed to remove order from group', err);
    }
  })
};

const handleDeleteGroup = async (group) => {
  askConfirm(`Are you sure you want to delete this shipping order "${group}"? This will remove all items from this shipping order.`, async () => {

    const ordersInGroup = orders.filter(order => order.shipping_group === group);
    try {
      await Promise.all(
        ordersInGroup.map(order =>
          api.put(`/orders/${order.id}`, { shipping_group: '' })
        )
      );
      fetchOrders(); // Refresh
    } catch (err) {
      console.error('Failed to delete group:', err);
    }
  })
};

  const handleFileChangePerOrder = (orderId, fileList) => {
  const filesArray = Array.from(fileList); // Convert FileList to array

  setSelectedFilesMap(prev => ({
    ...prev,
    [orderId]: filesArray
  }));

  // ✅ Reset upload status when a new file is selected
  setUploadStatusMap(prev => ({
    ...prev,
    [orderId]: ''
  }));
};


const uploadFilePerOrder = async (orderId) => {
  const files = selectedFilesMap[orderId];
  if (!files || files.length === 0) return;

  const formData = new FormData();
  files.forEach(file => {
    formData.append("files", file);
  });

  setUploadStatusMap(prev => ({ ...prev, [orderId]: '' }));
  setUploadingOrderId(orderId);
  setUploadProgressMap(prev => ({ ...prev, [orderId]: 0 }));

  try {
    const uploadResult = await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${API_BASE}/orders/${orderId}/uploads`);
      xhr.withCredentials = true;

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploadProgressMap(prev => ({ ...prev, [orderId]: percent }));
        }
      };

      xhr.onload = () => {
        const result = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          const uploadedNames = result.uploaded?.map(f => f.originalName).join(', ');
          setUploadStatusMap(prev => ({
            ...prev,
            [orderId]: `✅ Uploaded: ${uploadedNames}. Generating thumbnails...`
          }));
          resolve(result.uploaded);
        } else {
          const errorMsg = result?.error || 'Upload failed';
          setUploadStatusMap(prev => ({ ...prev, [orderId]: `❌ ${errorMsg}` }));
          reject(errorMsg);
        }
      };

      xhr.onerror = () => {
        setUploadStatusMap(prev => ({ ...prev, [orderId]: '❌ Upload failed' }));
        reject('XHR error');
      };

      xhr.send(formData);
    });

    // ✅ Poll for thumbnails
    const maxRetries = 10;
    const delay = (ms) => new Promise(res => setTimeout(res, ms));

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      const res = await fetch(`${API_BASE}/orders/${orderId}/files`, { credentials: 'include' });
      const files = await res.json();

      const allReady = files.every(file => {
        const ext = file.fullName?.split('.').pop()?.toLowerCase();
        return ['jpg', 'jpeg', 'png', 'mp4', 'mov', 'mpeg'].includes(ext)
          ? file.thumbnailExists
          : true;
      });

      if (allReady) {
        setUploadStatusMap(prev => ({ ...prev, [orderId]: `✅ Upload & processing complete.` }));
        setSelectedFilesMap(prev => {
          const updated = { ...prev };
          delete updated[orderId];
          return updated;
        });
        fetchOrders();
        break;
      }

      await delay(1500); // shorter retry delay
    }

  } catch (err) {
    console.error('Upload error:', err);
  } finally {
    setUploadingOrderId(null);
    setUploadProgressMap(prev => ({ ...prev, [orderId]: 0 }));
  }
};


const deleteFile = async (orderId, fullFileName) => {
  const fileNameOnly = fullFileName.replace(`${orderId}-`, '');
  askConfirm(`Delete file ${fileNameOnly}?`, async () => {
    try {
      const res = await fetch(`${API_BASE}/orders/uploads/${encodeURIComponent(fullFileName)}`, {
        method: 'DELETE',
        credentials: 'include'
      });


      if (res.ok) {
        setFileMap(prev => ({
          ...prev,
          [orderId]: prev[orderId].filter(f => f.fullName !== fullFileName)
        }));
      
      } else {
        const error = await res.json();
        showAlert(error.error || 'Failed to delete file.');
      }
    } catch (err) {
      console.error('Delete failed', err);
    }
  })
};

const fetchSingleOrderNotes = async (orderId) => {
  console.log('Updating notes for', orderId)
  try {
    const res = await api.get(`${API_BASE}/orders/${orderId}`);
    const rawNotes = res.data.notes;
    let parsedNotes = [];

    try {
      parsedNotes = Array.isArray(rawNotes)
        ? rawNotes
        : JSON.parse(rawNotes || '[]');
    } catch (e) {
      console.error('Failed to parse notes:', e);
    }

    setMessages((prev) => ({
      ...prev,
      [orderId]: parsedNotes,
    }));

    setTimeout(() => {
      const container = messagesContainerRefs.current[orderId];
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 50);
  } catch (err) {
    console.error('Error fetching order notes:', err);
  }
};


//Listen
useEffect(() => {
  const socket = new WebSocket(wsUrl());

  socket.onmessage = (event) => {
  try {
    const msg = JSON.parse(event.data);

    if (msg.type === 'ORDER_UPDATED') {
      const payload = JSON.parse(msg.orderId); // Actually contains { id, changes }
      const realOrderId = payload.id;
      const changes = payload.changes;

      if (!realOrderId) return;

      console.log('🔄 WebSocket update for order:', realOrderId);

      const trackedFields = [
        'notes',
        'price',
        'returnbydate',
        'returnetadate',
        'services_selected',
        'status',
        'tracking_number_in',
        'tracking_number_out',
        'tracking_number_in_date',
        'tracking_number_out_date',
        'appointment_date',
        'completed_date',
        'paid_on'
      ];

      const changedFields = [];

      trackedFields.forEach((field) => {
        const oldVal = changes[field]?.old;
        const newVal = changes[field]?.new;
        const changed = JSON.stringify(oldVal) !== JSON.stringify(newVal);
        if (changed) changedFields.push(field);
      });

      console.log('changedFields', changedFields);

      if (changedFields.includes('notes')) {
        fetchSingleOrderNotes(realOrderId);
      }
    }
  } catch (err) {
    console.error('WebSocket message error:', err);
  }
};


  return () => socket.close();
}, []);



  return (
    <>
      <TopNav />
      <div className="inventory-container">
        
          <>
            <h1 className={`inventory-title ${user.role === 'employee_la' ? 'hidden' : ''}`} >New Order</h1>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className={`${user.role === 'employee_la' ? 'hidden' : ''}`}>Inventory Item:</label>
                <div className="input-button-group">
                  <input type="text" placeholder="Serial Number or Name" value={form.serial_number || ''} onChange={handleSerialNumberChange} onKeyDown={(e) => { 
                    if (e.key === 'Enter' || e.key === 'Tab') {
                      e.preventDefault(); // Prevent form submission or tabbing away
                      findItem();
                    }
                  }} className="input" />
                  <button type="button" onClick={() => findItem()} className="button small blue">Find</button>
                </div>
   
                {matchedInventoryItem && (
                  <div className="status-message success">
                    Found: {matchedInventoryItem.name} (ID: {matchedInventoryItem.id})
                  </div>
                )}
                {serialNumberError && (
                  <div className="status-message error">{serialNumberError}</div>
                )}
                
                {matchedInventoryItems.length > 0 && (
                  <div className="status-message success">
                    Found: 
                    {matchedInventoryItems.map(item => (
                      <div>
                      <span key={item.id} className="match-item" onClick={() => handleSelectInventoryItem(item)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', padding: '4px 0' }} >
                        {item.name}: {item.serial_number} 

                        
                      </span>  
                      
                      { findExistingOrder(item)}

                      </div>
                    ))}
            
                    {serialNumberError && (
                      <div className="status-message error">{serialNumberError}</div>
                    )}
                  </div>
                )}
              </div>
              {user.role!=='employee_la' &&
                <>
                  <div className="form-group">
                    <label>Factory:</label>
                    <select value={form.provider_id} onChange={handleProviderChange} className="input" >
                      <option value="">Select a Factory</option>
                        {providers.map(provider => (
                          <option key={provider.id} value={provider.id}>{provider.name}</option>
                        ))}
                    </select>
                  </div>

                  {services.length > 0 && (
                    <div className="form-group">
                      <label>Services Offered:</label>
                      <div className="checkbox-group">
                        {services.map(service => (
                          <label key={service} className="checkbox-item">
                            <input type="checkbox" checked={selectedServices.includes(service)} onChange={() => toggleService(service)} />
                              {service}
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
              
                  <div className="form-group">
                    <label>Appointment Date:</label>
                    <input type="date" value={form.appointment_date || null} onChange={e => handleAppointmentDate(e.target.value)} className="input" />
                  </div>
  
                  <div className="form-group">
                    <label>Send By Date:</label>
                    <input type="date" value={form.returnbydate || null} onChange={e => handleReturnDate(e.target.value)} className="input" />
                  </div>
            
                  <button type="submit" className="button green">Add Order</button>
                </>
              }
            </form>

            {showInventoryModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <button onClick={() => setShowInventoryModal(false)} className="modal-close">×</button>
                    <InventoryForm serialNumber={form.serial_number} onClose={() => setShowInventoryModal(false)} onItemAdded={(newItem) => {
                      setMatchedInventoryItem(newItem);
                      setForm(f => ({ ...f, inventory_id: newItem.id }));
                      setShowAddToInventory(false);
                      setShowInventoryModal(false);
                      setSerialNumberError('');
                      loadData();
                    }} />
                </div>
              </div>
            )}

            {showTrackingModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <button onClick={() => setShowTrackingModal(false)} className="modal-close">×</button>
                  <h3>Enter Tracking Number</h3>
                  <input type="text" placeholder="Tracking Number" value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} className="input" />
                  <button onClick={submitTrackingNumber} className="button green">Submit</button>
                </div>
              </div>
            )}

            {isGroupModalOpen && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <button onClick={() => setIsGroupModalOpen(false)} className="modal-close">×</button>
                  <h3>Shipping Queue</h3>

                  {Array.from(new Set(orders.map(order => order.shipping_group)))
                    .filter(group => group)
                    .map(group => {
                      const groupOrders = orders.filter(order => order.shipping_group === group);
                      const providerName = groupOrders.length
                      ? providers.find(p => p.id === groupOrders[0].provider_id)?.name || 'Unknown'
                      : 'Unknown';

                    return (
                      <div key={group} className="order-card">
                        <div className="order-header">
                          <div className="order-meta">
                            <span className="order-label">Shipping Order:</span>
                            <span className="order-value">{group}</span>
                          </div>
                        </div>

                        <div className="order-content">
                          {groupOrders.map(order => {
                            const serial = inventory.find(i => i.id === order.inventory_id)?.serial_number || 'N/A';
                            return (
                              <div key={order.id} className="order-row">
                                <div className="order-meta">
                                  <span className="order-label">Order ID:</span>
                                  <span className="order-value">{order.id}</span>
                                </div>
                                <div className="order-meta">
                                  <span className="order-label">Serial Number:</span>
                                  <span className="order-value">{serial}</span>
                                </div>
                                <button className="remove-button" onClick={() => handleRemoveFromGroup(order)} >Remove</button>
                              </div>
                            );
                          })}
                        </div>

                        <div className="order-actions">
                          <input className="tracking-input" type="text" value={groupTrackingInputs[group] || ''} 
                            onChange={e =>
                              setGroupTrackingInputs(prev => ({ ...prev, [group]: e.target.value }))
                            } placeholder="Tracking number for this group" 
                          />
                          <button className="assign-button" disabled={!groupTrackingInputs[group]?.trim()} onClick={() => handleAssignTracking(group)} >Assign</button>
                          <button className="delete-group-button" onClick={() => handleDeleteGroup(group)} >Delete Shipping Order</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </>
        

        {user.role === 'admin' &&
          <p><button onClick={() => setIsGroupModalOpen(true)} className="button small blue">View Shipping Queue</button></p>
        }

        <h2 className="section-subheader">Current Queue</h2> 
        {/* Filters row */}
<div className="filters-row">
  <div className="form-group compact">
    <label>Filter by Status:</label>
    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      className="input"
    >
      <option value="All">All</option>
      <option value="New">New</option>
      <option value="Updated">Updated</option>
      <option value="Work in Progress">Work in Progress</option>
      <option value="Pending Shippment">Pending Shippment</option>
      <option value="Shipped to Factory">Shipped to Factory</option>
      <option value="Shipped to NY">Shipped to NY</option>
      <option value="Paid">Paid</option>
      <option value="Completed">Completed</option>
      <option value="Canceled">Canceled</option>
    </select>
  </div>

  <div className="form-group compact">
    <label>Filter by Factory:</label>
    <select
      value={factoryFilter}
      onChange={(e) => setFactoryFilter(e.target.value)}
      className="input"
    >
      <option value="All">All</option>
      {providers.map((p) => (
        <option key={p.id} value={String(p.id)}>
          {p.name}
        </option>
      ))}
    </select>
  </div>
</div>


  
        {selectedOrders.length > 0 && (
          <div className="bulk-actions">
            <span>{selectedOrders.length} selected</span>
            <div className="action-buttons">
              {statusFilter === 'Completed' && <button onClick={bulkBacktoQueue} className="button blue">Move back to Queue</button> }
              <button onClick={bulkPaid} className="button yellow">Paid</button>
              <button onClick={bulkDelete} className="button red">Delete</button>
              <button onClick={bulkComplete} className="button green">Mark Complete</button>
              <button onClick={CreateShipOrder} className="button blue">Ready to Ship</button>
              <button onClick={RemoveFromShippingGroup} className="button carmine">Remove from Shipping Order</button>
              <button onClick={bulkCancel} className="button carmine">Cancel</button>
            </div>
          </div>
        )}

        <div className="card-grid">
          {orders
            .filter(order => {
              if (statusFilter === 'All') return order.status !== 'Completed' && order.status !== 'Canceled';
              return order.status === statusFilter;
            })
            .filter(order => {
              if (factoryFilter === 'All') return true;
                return String(order.provider_id) === factoryFilter;
            })
            .map(order => {
              const inventoryItem = inventory.find(i => i.id === order.inventory_id)?.serial_number || '—';
              const itemName = inventory.find(i => i.id === order.inventory_id)?.name || '';
              const provider = providers.find(p => p.id === order.provider_id)?.name || '—';
              const isSelected = selectedOrders.includes(order.id);
              const providerObj = providers.find(p => p.id === order.provider_id);
              const servicesList = providerObj?.services_offered?.split(',').map(s => s.trim()) || [];
              const currentSelected = editedServicesMap[order.id] || (order.services_selected?.split(',').map(s => s.trim()) || []);

              const toggleEditedService = (service) => {
                setEditedServicesMap(prev => {
                  const prevServices = prev[order.id] || currentSelected;
                  const updated = prevServices.includes(service)
                  ? prevServices.filter(s => s !== service)
                  : [...prevServices, service];
                  return { ...prev, [order.id]: updated };
                });
              };
      
              return (
                <div key={order.id} className={`card ${order.status.toLowerCase()}`}>
                  {['New', 'Updated', 'Canceled'].includes(order.status) && (
                    <div className={`status-label ${order.status.toLowerCase()}`}>{order.status}</div>
                  )}
                  <div className="card-checkbox">
                    <input type="checkbox" checked={isSelected} disabled={user.role==='employee_la'} onChange={() => {
                      setSelectedOrders(prev =>
                        isSelected ? prev.filter(id => id !== order.id) : [...prev, order.id]
                      );
                    }}
                  />
                </div>

                <h3 className="card-title">Repair #{order.id}</h3>
                <p><strong>Serial:</strong> {inventoryItem}</p>
                <p><strong>Factory:</strong> {provider}</p>
                {(itemName !== '' && <p><strong>Name:</strong> {itemName}</p>)}
                {user.role === 'employee_la' 
                  ?
                  <p><strong>Services:</strong> {order.services_selected.trim()}</p>    
                  :
                  <p><a href="#" onClick={(e) => {e.preventDefault(); setEditingOrderId(order.id) }}><strong>Services</strong></a><strong>:</strong>   {order.services_selected.trim()}</p>
                }
                {editingOrderId && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h3>Edit Services for Order #{editingOrderId}</h3>
                      <div className="checkbox-group">
                        {(providers.find(p => p.id === orders.find(o => o.id === editingOrderId)?.provider_id)
                          ?.services_offered.split(',') || []
                          ).map(service => {
                            const trimmed = service.trim();
                            const availableServices = (providers.find(p => p.id === orders.find(o => o.id === editingOrderId)?.provider_id) ?.services_offered.split(',').map(s => s.trim())) || [];
                            const selectedRaw = editedServicesMap[editingOrderId] || orders.find(o => o.id === editingOrderId)?.services_selected?.split(',').map(s => s.trim()) || [];
                            const selected = selectedRaw.filter(s => availableServices.includes(s));

                            return (
                              <label key={trimmed} className="checkbox-item">
                                <input type="checkbox" checked={selected.includes(trimmed)} onChange={() =>
                                  setEditedServicesMap(prev => {
                                    const updated = selected.includes(trimmed)
                                    ? selected.filter(s => s !== trimmed)
                                    : [...selected, trimmed];
                                    return { ...prev, [editingOrderId]: updated };
                                  })
                                } />
                                {trimmed}
                              </label>
                            );
                          }
                        )}
                      </div>
                      <div className="modal-actions">
                        <button className="button green" onClick={() => {
                          handleSave(editingOrderId);
                          setEditingOrderId(null);
                        }}>Save</button>
                        <button className="button red" onClick={() => setEditingOrderId(null)}>Cancel</button>
                      </div>
                    </div>
                  </div>
                )}
       
                <p><strong>Status:</strong> {order.status} {order.status === 'Completed' && order.completed_date && `on ${formatDate(order.completed_date)}`}</p>
                {user.role === 'admin' && order.shipping_group &&
                  <p><strong>Shipping Queue:</strong> {order.shipping_group}</p>
                }
                <div className="order-field">
                  <strong>Appointment Date:</strong>{' '}
                  <input type="date" value={order.appointment_date ? order.appointment_date.split('T')[0] : null} onChange={e => handleAppointmentDateChange(order.id, e.target.value)}  />
                </div>
                <div className="order-field">
                  <strong>Send By:</strong>{' '}
                  <input type="date" disabled={user.role === 'employee_la'} value={order.returnbydate ? order.returnbydate.split('T')[0] : null} onChange={e => handleReturnDateChange(order.id, e.target.value)}  />
                </div>

                {order.returnetadate && <p className={ order.returnetadate && order.returnbydate &&  new Date(order.returnetadate) > new Date(order.returnbydate)  ? 'late-date'  : '' }>
                <strong>Send Back ETA: </strong>{order.returnetadate && formatDate(order.returnetadate)}</p>  }
            
                {order.tracking_number_in && user.role === 'admin' && <p><strong>Tracking #:</strong> <a href={getTrackingLinkAuto(order.tracking_number_in)} target="_blank" rel="noopener noreferrer">{order.tracking_number_in}</a></p> }
                {order.tracking_number_in && order.tracking_number_in_date && <p><strong>Shipped on:</strong> {formatDate(order.tracking_number_in_date)}</p> }
                {order.work_started_date  && ['admin', 'employee'].includes(user.role) && <p><strong>Work Started: </strong> {formatDate(order.work_started_date)}</p> }
                {order.price  && ['admin', 'employee'].includes(user.role) && <p><strong>Price: </strong> ${order.price}</p> }
                {order.paid_on  && ['admin', 'employee'].includes(user.role) && <p><strong>Paid on: </strong> {formatDate(order.paid_on)}</p> }
                {order.tracking_number_out && user.role === 'admin' && <p><strong>Return Tracking #:</strong> <a href={getTrackingLinkAuto(order.tracking_number_out)} target="_blank" rel="noopener noreferrer">{order.tracking_number_out}</a></p> }
                {order.tracking_number_out && order.tracking_number_out_date && <p><strong>Shipped back on:</strong> {formatDate(order.tracking_number_out_date)}</p> }
                <div className={`upload-group ${user.role === 'employee_la' ? 'hidden' : ''}`}>
                  <label>Upload File:</label>
                  <input type="file" multiple onChange={(e) => handleFileChangePerOrder(order.id, e.target.files)} accept=".mov,.mp4,.mpeg,.jpg,.jpeg,.png,.pdf" />

                  {(selectedFilesMap[order.id]?.length > 0 || uploadingOrderId === order.id) && (
                    <button type="button" className="button small green" disabled={uploadingOrderId === order.id} onClick={() => uploadFilePerOrder(order.id)} style={{ position: 'relative', overflow: 'hidden' }} >
                      {uploadingOrderId === order.id && (
                        <div style={{
                          width: `${uploadProgressMap[order.id] || 0}%`,
                          height: '100%',
                          backgroundColor: '#4caf50',
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          opacity: 0.3,
                          transition: 'width 0.2s ease'
                        }} />
                      )}
                      <span style={{ position: 'relative', zIndex: 1 }}>
                        {uploadingOrderId === order.id ? `Uploading ${uploadProgressMap[order.id]}%` : 'Upload'}
                      </span>
                    </button>
                  )}
                  {uploadStatusMap[order.id] && <p>{uploadStatusMap[order.id]}</p>}
                </div>

                {fileMap[order.id]?.length > 0 && (
                  <>
                    <p><strong>Files:</strong></p>
                    <div className="uploaded-files-container">
                      {fileMap[order.id]?.map(file => {
    
                        const urlWithoutQuery = file.url?.split('?')[0];
                        const ext = urlWithoutQuery?.split('.').pop()?.toLowerCase() || '';
                        const isImage = ['jpg', 'jpeg', 'png'].includes(ext);
                        const isVideo = ['mp4', 'mov', 'mpeg'].includes(ext);
                        const isPdf = ext === 'pdf';
                        const baseName = file.fullName.replace(/\.[^/.]+$/, '');
                        const thumbUrl = isImage
                        ? `${API_BASE}/uploads/thumbnails/${baseName}.webp`
                        : isVideo
                        ? `${API_BASE}/uploads/thumbnails/${baseName}.png`
                        : '';
                        return (
                          <div key={file.url} className="uploaded-file-item">
                            {
                              (isImage || isVideo) && file.thumbnailExists ? (
                                <div className="thumbnail-wrapper" onClick={() => openPreviewModal(`${API_BASE}${file.url}`, isImage ? 'image' : ext)} style={{ cursor: 'pointer' }} >
                                  <img src={thumbUrl} alt="Thumbnail" className="thumbnail" />
                                    {isVideo && (
                                      <div className="play-button-overlay">▶</div>
                                    )}
                                </div>
                              ) 
                              : 
                              (isImage || isVideo) ? (
                                <div style={{
                                  width: 100,
                                  height: 100,
                                  background: '#eee',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }} > Processing... </div>
                              ) : null
                            }

                            {isPdf && (
                              <div className="pdf-thumbnail" onClick={() => window.open(`${API_BASE}${file.url}`, '_blank', 'noopener,noreferrer')} style={{ cursor: 'pointer' }} >📄</div>
                            )}
                            <button className={`button tiny red ${user.role === 'employee_la' ? 'hidden' : ''}`} onClick={() => deleteFile(order.id, file.url?.split('/').pop())} > × </button>
                          </div>
                        );
                      })}
                    </div>

                  </>
                )}

                {previewUrl && (
                  <div className="video-modal">
                    <div className="video-modal-content">
                      <button className="video-modal-close" onClick={() => setPreviewUrl(null)}>×</button>
                      {(['mp4', 'mpeg', 'mov'].includes(previewType)) && (
                        <video controls style={{ width: '100%', maxHeight: '80vh' }}>
                          <source src={`${previewUrl}`} type={`video/${(previewType === 'mov' ? 'quicktime' : previewType)}`} />
                            Your browser does not support the video tag.
                        </video>
                      )}
                      {previewType === 'image' && (
                        <img src={`${previewUrl}`} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
                      )}
                    </div>
                  </div>
                )}

                {videoModalUrl && (
                  <div className="video-modal">
                    <div className="video-modal-content">
                      <button className="video-modal-close" onClick={() => setVideoModalUrl(null)}>×</button>
                      <video controls autoPlay style={{ width: '100%', maxHeight: '80vh' }}>
                        <source src={`${API_BASE}${videoModalUrl}`} type="video/mp4" />
                          Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                )}
          
                <div className="chat-box">
                  <div  ref={el => { messagesContainerRefs.current[order.id] = el; }} id={order.id} className="chat-messages" >
                    {(messages[order.id] || []).map((msg, index) => (
                      <div key={index} style={{ marginBottom: '8px' }}>
                        <strong>{msg.sender}</strong>{' '}
                        <small>{new Date(msg.timestamp).toLocaleString()}</small>
                        <div>{msg.text}</div>
                      </div>
                    ))}
                  </div>
      
                  <textarea className={`${user.role === 'employee_la' ? 'hidden' : ''}`} rows={4} placeholder="Type a message..." value={newMessage[order.id] || ''} onChange={(e) => {
                      setNewMessage(prev => ({ ...prev, [order.id]: e.target.value }));
                    }} onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault(); // prevent newline
                        handleSendMessage(order.id, newMessage[order.id]);
                        setNewMessage(prev => ({ ...prev, [order.id]: '' }));
                      }
                    }} style={{ width: '99%', resize: 'none', marginBottom: '8px' }}  
                  />
                  <div style={{ textAlign: 'right' }}>
                    <button className={`button small blue send ${user.role === 'employee_la' ? 'hidden' : ''}`} onClick={() => {
                      handleSendMessage(order.id, newMessage[order.id]);
                      setNewMessage(prev => ({ ...prev, [order.id]: '' }));
                    }} > Send </button>
                  </div>
                </div>
                {/*
                  <div className="card-actions">
                    <button onClick={() => handleDelete(order.id)} className="button small red">Delete</button>
                    <button onClick={() => handleComplete(order.id)} className="button small green">Complete</button>
                    <button onClick={() => handleSave(order.id)} className="button small yellow">Update</button>
                    <button onClick={() => handleCancel(order.id)} className="button small carmine" >Cancel</button>
                  </div>
                */}
        </div>
      );
    })}
  </div>
</div>
    {alertState.open && (
      <AlertModal message={alertState.message} onClose={() => setAlertState({ open: false, message: '' })} />
    )}
    {confirmState.open && (
      <ConfirmModal open={confirmState.open} message={confirmState.message} onConfirm={confirmState.onConfirm} onCancel={() => setConfirmState({ open: false, message: '', onConfirm: () => {} })  } />
    )}

    </>
  );
}

export default OrdersPage;
